import 'javascripts/jquery-ui/dialog'
import { jqTextCopy } from 'javascripts/general_scripts'

/* stylesheet */
import 'stylesheets/share_this.less'
import 'jquery-ui/themes/base/dialog'
import 'jquery-ui/themes/base/button'

const share_dialog = $('#share_this');
var share_modal = share_dialog.dialog({
    dialogClass: "gitb-modal share-dialog",
    disabled: true,
    width: 500,
    modal: true,
    autoOpen: false,
    closeText: 'hide',
    open(event, ui) {
        $('.ui-widget-overlay').on('click', () => share_modal.dialog('close'));
    }
});

$(document).on('click', '.share-this', function() {
    share_dialog.find('#share-url').val($(this).data('share-url'));
    share_dialog.find('button[data-gitb-copy-text]').attr('data-gitb-copy-text', $(this).data('share-url'));
    share_modal.dialog('open');
    return false;
});

jqTextCopy();